import { Component, Vue, Watch } from 'vue-property-decorator';
import RequestButtonDataTable from '@/components/request/RequestButtonDataTable/RequestButtonDataTable.vue';
import RequestButtonKanbanBoard from '@/components/request/RequestButtonKanbanBoard/RequestButtonKanbanBoard.vue';
import RequestButtonCreate from '@/components/request/RequestButtonCreate/RequestButtonCreate.vue';
import RequestDataTable from '@/components/request/RequestDataTable/RequestDataTable';
import RequestDialogCreate from '@/components/request/RequestDialogCreate/RequestDialogCreate.vue';
import RequestKanbanBoard from '@/components/request/RequestKanbanBoard/RequestKanbanBoard';

@Component<Requests>({
  components: {
    'request-button-data-table': RequestButtonDataTable,
    'request-button-kanban-board': RequestButtonKanbanBoard,
    'request-button-create': RequestButtonCreate,
    'request-data-table': RequestDataTable,
    'request-dialog-create': RequestDialogCreate,
    'request-kanban-board': RequestKanbanBoard,
  }
})
export default class Requests extends Vue {
  protected viewType: RequestViewType = 'kanban';

  protected showCreateDialog = false;

  protected showFilter = true;

  protected user = this.$store.state.Auth;

  protected handleCreateClick(): void {
    this.showCreateDialog = true;
  }

  protected handleCreateSuccess(): void {
    if (this.dataTable) { this.dataTable.refresh(); }
    if (this.kanbanBoard) { this.kanbanBoard.refresh(); }
  }

  protected get showDataTable(): boolean {
    return this.viewType === 'data-table';
  }

  protected get showKanbanBoard(): boolean {
    return this.viewType === 'kanban';
  }

  protected get isPlanner() {
    if (! this.$store || !this.$store.state || ! this.$store.state.Auth) {
      return false;
    }

    // @ts-ignore
    return this.$store.state.Auth.isPlanner()
  }

  protected get dataTable(): RequestDataTable | null {
    return this.$refs.dataTable ? this.$refs.dataTable as RequestDataTable : null;
  }

  protected get kanbanBoard(): RequestKanbanBoard | null {
    return this.$refs.kanbanBoard ? this.$refs.kanbanBoard as RequestKanbanBoard : null;
  }

  @Watch('viewType')
  protected viewTypeChanged(): void {
    const page = document.getElementsByClassName('kanbanPage')[0];
    if (!page) { return }
    if (this.viewType === 'data-table') {
      (page as HTMLDivElement).classList.add('overflow')
    } else {
      (page as HTMLDivElement).classList.remove('overflow')
    }
  }
}



export type RequestViewType = 'data-table' | 'kanban';
